function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import customerCareKeys from '../../../../locales/keys';
var REMOVED_MEMBER = 2;
var MemberListItemController = /*#__PURE__*/function () {
  function MemberListItemController() {
    _classCallCheck(this, MemberListItemController);
    this.customerCareKeys = customerCareKeys;
  }
  return _createClass(MemberListItemController, [{
    key: "selectItem",
    value: function selectItem() {
      this.onItemSelected()(this.item);
    }
  }, {
    key: "isRemovedMember",
    get: function get() {
      return this.item.Status === REMOVED_MEMBER;
    }
  }, {
    key: "isHeadOfHousehold",
    get: function get() {
      return this.item.SubscriberId === this.headOfHouseholdId;
    }
  }, {
    key: "memberPrivilegesInfo",
    get: function get() {
      return this.item.Privileges.MemberManagementEnabled ? "".concat(i18n.translate(this.customerCareKeys.HOUSEHOLD.MEMBER), " (").concat(i18n.translate(this.customerCareKeys.HOUSEHOLD.FULL_ACCESS_PRIVILEGES), ")") : this.item.Privileges.ManageServicesEnabled ? "".concat(i18n.translate(this.customerCareKeys.HOUSEHOLD.MEMBER), " (").concat(i18n.translate(this.customerCareKeys.HOUSEHOLD.SERVICE_LEVEL_PRIVILEGES), ")") : i18n.translate(this.customerCareKeys.HOUSEHOLD.MEMBER);
    }
  }]);
}();
export default {
  template: require('./member.list.item.html'),
  bindings: {
    headOfHouseholdId: '<',
    item: '<',
    isSelectedItem: '<',
    onItemSelected: '&'
  },
  controller: MemberListItemController
};